import React from 'react';
import { Link } from 'react-router-dom';
import BrandMark from './BrandMark';

function MarketingNav({ activeLink = 'home' }) {
  return (
    <nav>
      <Link to="/" className="brand">
        <BrandMark />
        <span className="name">Nurturer</span>
      </Link>
      <div className="navlinks">
        <Link to="/" className={activeLink === 'home' ? 'active' : undefined}>
          Home
        </Link>
        <Link to="/contact-us" className={activeLink === 'contact' ? 'active' : undefined}>
          Contact Us
        </Link>
        <Link to="/login" className="nav-login">
          Log in
        </Link>
      </div>
    </nav>
  );
}

export default MarketingNav;
